var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgFeedback = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M7.757 7.2h8.357c.279 0 .836.172.836.862v6.607c0 .288-.167.862-.836.862H8.86L7.2 16.95V8.062c0-.287.111-.862.557-.862M9.8 9.45a.35.35 0 1 0 0 .7h4.55a.35.35 0 0 0 0-.7zm0 3a.35.35 0 1 0 0 .7h4.55a.35.35 0 1 0 0-.7zm-.35-1.15a.35.35 0 0 1 .35-.35h4.55a.35.35 0 1 1 0 .7H9.8a.35.35 0 0 1-.35-.35",
    clipRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFeedback);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/feedback.a8449790.svg";